import React from 'react';
import Card from '../../../components/card/Card';
import H from '../../../components/texts/h/H';
import P from '../../../components/texts/p/P';
import Span from '../../../components/texts/span/Span';
import theme from '../../../styles/theme';

type AtlanticCompanyHeaderProps = {
  companyName?: string | null;
  activity?: string | null;
  referrer?: string | null;
  showCompanyName?: boolean;
  showActivity?: boolean;
  showReferrer?: boolean;
};

const displayValue = (value?: string | null): string => {
  const trimmed = value?.trim();
  return trimmed || '-';
};

const AtlanticCompanyHeader: React.FC<AtlanticCompanyHeaderProps> = ({
  companyName,
  activity,
  referrer,
  showCompanyName = true,
  showActivity = true,
  showReferrer = true,
}) => {
  const trimmedActivity = activity?.trim();
  const shouldRender = showCompanyName || showActivity || showReferrer;

  if (!shouldRender) return null;

  return (
    <div data-testid="atlantic-company-header" style={{ width: '100%', maxWidth: '100%' }}>
      <Card
        margin={{ bottom: '4' }}
        border={false}
        borderRadius
        borderRadiusAmount="3"
        spacing="0"
        variant="none"
        display="flex"
        flexDirection="column"
        gap="16px"
        width="100%"
        maxWidth="100%"
        style={{
          background: 'transparent',
          border: `1px solid ${theme.colors.neutral.border.weak}`,
          boxSizing: 'border-box',
          padding: theme.spacing['spacing-5'],
        }}
      >
        <Span type="4" variant="neutral" modifier="strong" weight="bold">
          EMPRESA
        </Span>
        {showCompanyName && (
          <H type="4" variant="neutral-1" withMargin={false} weight="bold" modifier="strong">
            {displayValue(companyName)}
          </H>
        )}
        {showActivity && trimmedActivity && (
          <P type="2" variant="neutral" withMargin={false}>
            {trimmedActivity}
          </P>
        )}
        {showReferrer && (
          <P type="2" variant="neutral" withMargin={false}>
            Cargada por:{' '}
            <Span type="2" variant="neutral" weight="bold">
              {displayValue(referrer)}
            </Span>
          </P>
        )}
      </Card>
    </div>
  );
};

export default AtlanticCompanyHeader;
